var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{[`bg-gradient-${_vm.type}`]: _vm.type}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }